import React from 'react';
import { string, number } from 'prop-types';
import './AmexGDAB2BTestimonialsCard.scss';
import { sanitizeString } from '../../../../../../../ui-kitchen/src/utils/sanitizeString';

const AmexGDAB2BTestimonialsCard = (
  {
    imagePathPrefix,
    bg_image: bgImage,
    name,
    text,
    index,
  }
) => {
  const sanitizedName = sanitizeString(name);
  const sanitizedText = sanitizeString(text);

  return (
    <div className="AmexGDAB2BTestimonialsCard__inner">
      <div className="AmexGDAB2BTestimonialsCard__wrapper">
        <h3
          id={`slide_heading${index}`}
          className="AmexGDAB2BTestimonialsCard__name"
          dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
            __html: sanitizedName,
          }}
        />
      </div>
      <div className="AmexGDAB2BTestimonialsCard__img">
        <img src={`${imagePathPrefix}${bgImage}`} alt="" />
      </div>
      <div className="AmexGDAB2BTestimonialsCard__body">
        <p
          className="AmexGDAB2BTestimonialsCard__copy"
          dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
            __html: sanitizedText,
          }}
        />
      </div>
    </div>
  );
};

AmexGDAB2BTestimonialsCard.propTypes = {
  imagePathPrefix: string.isRequired,
  index: number.isRequired,
  bg_image: string.isRequired,
  name: string.isRequired,
  text: string.isRequired,
};

export default AmexGDAB2BTestimonialsCard;
